/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .header[_ngcontent-%COMP%]{display:flex;flex-direction:row-reverse;margin-bottom:9px}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]{padding:15px;border-radius:6px;box-shadow:0 0 10px 0 rgba(106,106,106,.3);background-color:#fff}[table][_nghost-%COMP%]   .content[_ngcontent-%COMP%]{min-width:710px}"];
export { styles as styles };
